import loadable from '@loadable/component';

import { LoadingPageLoadable } from 'modules/main/pages/Loading';

export const NotificationsLinksPageLoadable = loadable(
  () => import('./NotificationsLinksPage.dynamic'),
  { fallback: <LoadingPageLoadable /> },
);
